import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Spinner from 'src/components/atoms/spinner/spinner';
import { RootState, useAppDispatch, useAppSelector } from 'src/reducers';
import { searchUserById } from 'src/reducers/user.reducer';
import { AnagraphicForm } from './anagraphic-form';

export const Anagraphic = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const id = Number(params.id);

  const { searchLoading, searchFailure, searchSuccess, user } = useAppSelector((state: RootState) => state.user);

  useEffect(() => {
    dispatch(searchUserById({ id: id }));
  }, [id, dispatch]);

  return (
    <>
      {searchLoading && <Spinner />}
      {!searchLoading && searchFailure && <div>Errore nell'ottenimento dei dati</div>}
      {!searchLoading && searchSuccess && user && <AnagraphicForm userId={id} anagraphic={user?.anagraphic} />}
    </>
  );
};
